import * as actionTypes from "./types";
import { ACTION_ERROR } from "../exception-handler/types";

const initialState = {
  industries: null,
  loading: false,
};

export const industriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_INDUSTRIES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.GET_INDUSTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        industries: action.payload,
      };
    case ACTION_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
